import { css } from '@emotion/css';
import { EmbedHeader, HeaderFixed } from '@/components';
import { EmbeddedJarFilters } from './EmbeddedJarFilters';
import { useURLSearchParams } from '@/hooks';

export const EmbeddedJarHeader = () => {
  const { audienceId, audienceType, districtId } = useURLSearchParams();
  return (
    <HeaderFixed className={cn.container}>
      <EmbedHeader districtId={districtId} audienceId={audienceId} audienceType={audienceType} />
      <EmbeddedJarFilters />
    </HeaderFixed>
  );
};


const cn = {
  container: css`
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 360px) and (hover: hover) and (pointer: fine) {
      position: static;
    }
  `,
};